import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";


export const useTagiFull = (enabled=true) => {
    return useQuery({
        queryKey: ['tagi_lista_full'],
        queryFn: async () => getList('/rejestr/tag/pelna-lista'),
        refetchOnMount: false,
        enabled
    })
}